import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column footer-brand-col">
              <div className="footer-logo-wrap">
                <div className="footer-icon-horse">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m7 10l-.85 8.507A1.357 1.357 0 0 0 7.5 20h.146a2 2 0 0 0 1.857-1.257l.994-2.486A2 2 0 0 1 12.354 15h1.292a2 2 0 0 1 1.857 1.257l.994 2.486A2 2 0 0 0 18.354 20h.146a1.37 1.37 0 0 0 1.364-1.494L19 9h-8c0-3-3-5-6-5l-3 6l2 2zm15 4v-2a3 3 0 0 0-3-3"
                    ></path>
                  </svg>
                </div>
                <span className="footer-brand-name section-title">Ketame</span>
              </div>
              <p className="footer-tagline section-content">
                {' '}
                The official stable of Mike the Blue Horse. Absurd webcomics,
                spicy meme-panels, and horse-centric surrealism for the internet
                age.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer-social-links">
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22 4.01c-1 .49-1.98.689-3 .99c-1.121-1.265-2.783-1.335-4.38-.737S11.977 6.323 12 8v1c-3.245.083-6.135-1.395-8-4c0 0-4.182 7.433 4 11c-1.872 1.247-3.739 2.088-6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58-1.04 6.522-3.723 7.651-7.742a13.8 13.8 0 0 0 .497-3.753c0-.249 1.51-2.772 1.818-4.013z"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Instagram" className="footer-social-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="M4 8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"></path>
                        <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0m7.5-4.5v.01"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="RSS Feed" className="footer-social-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 19a1 1 0 1 0 2 0a1 1 0 1 0-2 0M4 4a16 16 0 0 1 16 16M4 11a9 9 0 0 1 9 9"
                      ></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-column footer-nav-col">
              <h2 className="footer-col-title section-subtitle">
                The Archives
              </h2>
              <nav className="footer-nav">
                <ul className="footer-nav-list">
                  <li className="footer-nav-item">
                    <a href="/">
                      <div className="footer-nav-link">
                        <span>Latest Episodes</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="/archive-series">
                      <div className="footer-nav-link">
                        <span>Comic Archive</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="/archive-series">
                      <div className="footer-nav-link">
                        <span>Series &amp; Sagas</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Character Bios</span>
                      </div>
                    </a>
                  </li>
                  <li className="footer-nav-item">
                    <a href="#">
                      <div className="footer-nav-link">
                        <span>Meme Generator</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="footer-column footer-sub-col">
              <h2 className="footer-col-title section-subtitle">Stable Mail</h2>
              <p className="footer-sub-text section-content">
                Get new episodes delivered directly to your feed before the
                algorithms eat them.
              </p>
              <form
                action="/subscribe"
                method="POST"
                data-form-id="57c50a4d-7744-4199-8319-3ae4e8436f85"
                className="footer-form"
              >
                <div className="footer-input-group">
                  <label
                    htmlFor="footer-email"
                    className="footer-visually-hidden"
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="footer-email"
                    placeholder="horse@internet.meme"
                    required="true"
                    name="textinput"
                    data-form-field-id="footer-email"
                    className="footer-input"
                  />
                  <button
                    type="submit"
                    aria-label="Subscribe"
                    id="thq_button_ro4k"
                    name="button"
                    data-form-field-id="thq_button_ro4k"
                    className="footer-submit-btn btn btn-primary"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      </g>
                    </svg>
                  </button>
                </div>
                <div id="form-feedback" className="footer-form-feedback">
                  <span>Thanks! Check your inbox for a carrot.</span>
                </div>
              </form>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-legal">
              <span className="footer-copy">
                &amp;copy; 2026 Ketame Universe. All rights weird.
              </span>
              <div className="footer-legal-links">
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-legal-link">
                    <span>Terms of Absurdity</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-mascot-peeker">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M3.5 17.5q8.5 7 17 0"></path>
                  <path d="M19 18.5L17 10l1-2l2 1l1.5-1.5L19 3c-5.052.218-5.99 3.133-7 6H6a3 3 0 0 0-3 3m2 6.5L7 9"></path>
                  <path d="m8 20l2-5h4l2 5"></path>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-logic">
(function(){
  const footerForm = document.querySelector('.footer-form');
  const feedbackMsg = document.getElementById('form-feedback');

  if (footerForm) {
    footerForm.addEventListener('submit', (e) => {
      // We allow native validation to occur first
      // This is just for the UX success state display
      setTimeout(() => {
        if (footerForm.checkValidity()) {
          feedbackMsg.style.display = 'block';
          footerForm.reset();
          
          // Hide message after 5 seconds
          setTimeout(() => {
            feedbackMsg.style.display = 'none';
          }, 5000);
        }
      }, 10);
    });
  }

  // Subtle parallax for the mascot peeker
  window.addEventListener('scroll', () => {
    const peeker = document.querySelector('.footer-mascot-peeker');
    if (peeker) {
      const scrollPos = window.pageYOffset;
      const footerPos = document.querySelector('.footer-root').offsetTop;
      const winHeight = window.innerHeight;
      
      if (scrollPos > footerPos - winHeight) {
        const offset = (scrollPos - (footerPos - winHeight)) * 0.05;
        peeker.style.transform = \`translateY(\${10 - offset}px) rotate(\${-10 + (offset/2)}deg)\`;
      }
    }
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
